import service from '@/store/services/biotimes/biotime-devices-service';

const state = {
    list: {},
    biotimeDevice: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, biotimeDevice) => {
        state.biotimeDevice = biotimeDevice;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(biotimeDevice => {
                commit('SET_RESOURCE', biotimeDevice);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(biotimeDevice => {
                commit('SET_RESOURCE', biotimeDevice);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((biotimeDevice) => {
                commit('SET_RESOURCE', biotimeDevice);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((biotimeDevice) => {
                commit('SET_RESOURCE', biotimeDevice);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    biotimeDevice: state => state.biotimeDevice,
    dropdown: (state) => {
        return state.list.map(biotimeDevice => ({
            id: biotimeDevice.id,
        }));
    }
};

const biotimeDevices = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default biotimeDevices;
